<template>
  <div class="w-100">
    <div class="w-100" :class="{ 'border-b-semi-grey-dashed-2 mb-4 pb-4' : product_index+1 < getOutletTrxProducts.length || (product_index+1 == getOutletTrxProducts.length && product_i+1 < product_list.length) }" v-for="(product,product_i) in product_list">
      <div class="row no-gutters">
        <div class="col-1">
          <p class="text-14 text-center font-lato w-100 py-2 radius-6 border-form bg-grey-dark lh-1">{{ product.qty }}x</p>
        </div>
        <div class="col-7">
          <div class="pl-3">
            <p class="mb-0 body-2-1">{{ product.name }}</p>
            <p class="body-3-3-1 mb-1 w-100">Note : <b>{{ product.notes }}</b></p>
            <p class="mb-0 body-3-3-2 text-green cursor-pointer" @click="goToDetailProduct()">EDIT</p>
          </div>
        </div>
        <div class="col-4 text-right">
          <p class="mb-0 text-12 font-lato text-semi-light text-line-through" v-if="product.price_discount > 0">{{ $formatCurrency(product.base_price) }}</p>
          <p class="mb-0 text-14 font-lato">{{ $formatCurrency(product.price) }}</p>
          <p class="mb-0 body-3-3-2 text-danger cursor-pointer" @click="removeProduct(product)">REMOVE</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters,mapMutations } from 'vuex'

  export default {
    props: ['data','product_index'],
    data() {
      return {
        
      }
    },
    computed:{
      ...mapGetters(['getOutletTrxProducts','getMerchant']),
      pos_code(){
        return this.$route.params.pos_code
      },
      is_variant(){
        return this.data.variants.length > 0 ? true : false
      },
      product_list(){
        let return_data = []
        if(this.is_variant){
          this.data.variants.forEach(variant=>{
            let price = variant.variant_data.price
            let base_price = price.tax_service_calculation_type == 'INCLUDE' ? price.price_sell_base : price.price_sell_base + price.service_amount + price.tax_amount
            let data = {
              original : variant,
              name: `${variant.variant_data.name} - ${this.data.product_data.name}`,
              price: price.price_sell_final_with_tax_service*variant.qty,
              base_price: base_price*variant.qty,
              price_discount: price.promotion_amount*variant.qty,
              qty: variant.qty,
              notes: variant.notes
            }
            return_data.push(data)
          })
        }else{
          let price = this.data.product_data.price
          let base_price = price.tax_service_calculation_type == 'INCLUDE' ? price.price_sell_base : price.price_sell_base + price.service_amount + price.tax_amount
          let data = {
            original : this.data,
            name: this.data.product_data.name,
            price: price.price_sell_final_with_tax_service*this.data.qty,
            base_price: base_price*this.data.qty,
            price_discount: price.promotion_amount*this.data.qty,
            qty: this.data.qty,
            notes: this.data.notes
          }
          
          return_data.push(data)
        }

        return return_data
      },
    },
    methods:{
      ...mapMutations(['removeTrxOutletProduct']),
      goToDetailProduct() {
        let route = {
          name: 'PosProductDetail',
          params: {
            merchant_code: this.getMerchant.code,
            pos_code: this.pos_code,
            product_id: this.data.product_data.id
          },
          query: {
            pos_id: this.data.product_data.product_pos[0].id,
            from: 'PosCart'
          }
        }
        this.$router.push(route)
      },
      removeProduct(product){
        let params = {
          product: this.data.product_data,
          variant: this.is_variant ? product.original.variant_data : [],
          ref:  this.is_variant ? 'variant' : 'product',
          qty: product.qty,
          notes: product.notes
        }
        this.removeTrxOutletProduct(params)
      }
    }
  }
</script>
<style>
  .pos-order-qty {
    cursor: pointer;
    width: 28px;
    height: 28px;
    display: grid;
    place-items: center;
    text-align: center;
    border-radius: 6px;
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/concierge/pos/ProductCart.vue